import React, { useState, useContext } from 'react'
import { Table } from 'react-bootstrap'
import styled from 'styled-components'
import AccountRow from './AccountRow'
import { getFromLocalStorage } from '../../../helper/storage'
import { JazeelContext } from '../../../utils/JazeelContext'
import { deleteSocialMediaData } from '../../../services/services'
import PropTypes from 'prop-types'
const ConnectedAccountsContainer = styled(Table)`
  padding-top: 0.625em;
  &.table thead th {
    border-top: 0;
    border-bottom: 1px solid #dee2e6;
    color: #b1b1b1;
    font-weight: 200;
  }
  button {
    display: inline-block;
    line-height: 1.875em;
    width: 6.875em;
    padding: 0 0.625em;
    font-size: 0.875em;
    vertical-align: sub;
  }
  .spinner-border-sm {
    border-width: 0.1em;
    vertical-align: sub;
  }
`
export default function ConnectedAccounts({ setLength, loading, setLoading }) {
  // TODO: store connected accounts in LocalStorage
  const { userData } = useContext(JazeelContext)
  const [accounts, setAccounts] = useState(
    getFromLocalStorage('userData:')?.social_media_data,
  )
  const removeAccount = account => {
    setLoading(true)
    deleteSocialMediaData(account, userData).then(r => {
      if (r) {
        setAccounts(getFromLocalStorage('userData:').social_media_data)
        setLength(
          Object.keys(accounts).filter(account => accounts[account]).length - 1,
        )
        setLoading(false)
      }
    })
  }
  const renderAccount = () => {
    if (accounts) {
      return Object.keys(accounts).map(account => {
        let data = accounts[account]
        if (data) {
          console.log('this account', account)
          return (
            <AccountRow
              loading={loading}
              key={account}
              data={data}
              removeAccount={removeAccount}
              account={account}
            />
          )
        }
      })
    }
  }

  return (
    <ConnectedAccountsContainer responsive>
      <thead>
        <tr>
          <th>Platform</th>
          <th>Account Name</th>
          <th>Followers</th>
          <th>Avg. Reach</th>
          <th>Income Earned</th>
        </tr>
      </thead>
      <tbody>{renderAccount()}</tbody>
    </ConnectedAccountsContainer>
  )
}
ConnectedAccounts.propTypes = {
  setLength: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
}
